import * as React from 'react'
import clsx from 'clsx'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import style from '../../style'
import { useGridApiContext } from '../../hooks/utils/useGridApiContext'

interface GridColumnHeadersInnerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  isDragging: boolean
}

export const GridColumnHeadersInner = React.forwardRef<
  HTMLDivElement,
  GridColumnHeadersInnerProps
>(function GridColumnHeadersInner(props, ref) {
  const { isDragging, children, ...other } = props
  const apiRef = useGridApiContext()
  const rootProps = useGridRootProps()

  const hasScrollX = apiRef.current.getRootDimensions()?.hasScrollX ?? false

  return (
    <div
      ref={ref}
      className={clsx(
        style.columnHeadersInner,
        rootProps.classes?.columnHeadersInner,
        isDragging && [
          style.columnHeaderDropZone,
          rootProps.classes?.columnHeaderDropZone,
        ],
        hasScrollX && [
          style['columnHeadersInner--scrollable'],
          rootProps.classes?.['columnHeadersInner--scrollable'],
        ]
      )}
      {...other}
    >
      {children}
    </div>
  )
})
